// Code generated by rule_operators_tsgen_test.go; DO NOT EDIT.
// The rule operator classes of governance-service models.NoValueOperators and models.MultiValueOperators.
// Regenerate: cd platform/agion-core/governance-service && go test ./internal/models -run TestGeneratedRuleOperatorsIsCurrent -update
// Body SHA-256: ba8996bbd21af77221134d6d19cd99d6c08c8b6a767a65b3b8dcfdeca89e166d

/** The rule operators whose condition carries no value: they ask only whether the field is present. */
export const NO_VALUE_OPERATORS: readonly string[] = ['exists', 'not_exists']

/** The rule operators whose condition value is a list of members. */
export const MULTI_VALUE_OPERATORS: readonly string[] = ['in', 'not_in']
